import {connect} from 'react-redux';
import SquadDeleteConfirmModal from './SquadDeleteConfirmModal.jsx';
import {handleCloseDeleteModal, handleConfirmSquadDelete} from './actions.js';

const mapStateToProps = state => state.tournament.squads.squadDeleteConfirmModal;

const mapDispatchToProps = dispatch => ({
  onCancelClick: () => dispatch(handleCloseDeleteModal()),
  onConfirmDeleteClick: (option, confirmation) => dispatch(handleConfirmSquadDelete(option, confirmation))
});

export default connect(mapStateToProps, mapDispatchToProps)(SquadDeleteConfirmModal);



// WEBPACK FOOTER //
// ./src/features/tournament/squads/SquadDeleteConfirmModalContainer.jsx